import { Center, Spinner } from "@chakra-ui/react";

export default function Loading() {
  return (
    <Center my="32px">
      <Spinner size="xl" color="brand.500" />
    </Center>
  );
}
